const sentryConfig = {
  dsn: "https://fd718325cde14ccebd0833f62e104399@o234395.ingest.sentry.io/5757378",
  tracesSampleRate: 0,
  environment: "dev",
  release: "c031acea785cd058803c35266dacdaaf4af4ed8d-Ubuntu7Standard:590033bf-bbb1-4a26-a66d-9caf10faf822",
};

export default sentryConfig;
